import React from 'react';
import styled from 'styled-components';

const Btn = styled.button<{ $color?: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: ${(p) => p.theme.radius};
  border: 1px solid ${(p) => p.theme.border};
  background: ${(p) => p.theme.surface};
  color: ${(p) => p.$color || p.theme.textSecondary};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    background: ${(p) => p.theme.surfaceAlt};
    border-color: ${(p) => p.$color || p.theme.primary};
    color: ${(p) => p.$color || p.theme.primary};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

interface ActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color?: string;
}

export const ActionButton: React.FC<ActionButtonProps> = ({ color, children, ...rest }) => (
  <Btn $color={color} {...rest}>
    {children}
  </Btn>
);

export default ActionButton;
